import config from './config';

function hideOverlay(overlay) {
  overlay.animate({
    opacity: 0,
  }, 100, () => {
    overlay.addClass('hidden');
  });
}

function showOverlay(overlay, opacity) {
  overlay.removeClass('hidden');
  overlay.animate({
    opacity: opacity || 0.7,
  }, 100);
}

function setOverlaySize(overlay) {
  overlay.height(config.$el.document.height());
}

export default {
  hideOverlay,
  showOverlay,
  resize: setOverlaySize,
  init: setOverlaySize,
};



// WEBPACK FOOTER //
// ./front/iko-app-lite/js/app/overlay.js